import { DataTableColumnDef } from 'components/data-table';
import type { DevelopmentArea } from 'types/api-responses';
import { format0, formatNumber } from 'utils/number';
import style from './type-curve-wells-table.module.scss';

const formatAcreage = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '--';
  return formatNumber(value, 3, 3);
};

export const unitsTableColumns: DataTableColumnDef<DevelopmentArea>[] = [
  {
    accessorKey: 'unitName',
    id: 'unitName',
    header: 'Unit Name',
    size: 180,
    cell: (info) => (info.getValue() as string) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'name',
    id: 'name',
    header: 'Name',
    size: 160,
    cell: (info) => {
      const name = info.getValue() as string;
      const href = info.row.original.href;
      if (name && href) {
        return (
          <a
            href={href}
            className={style.wellLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {name}
          </a>
        );
      }
      return name || '--';
    },
    meta: { type: 'text' },
  },
  {
    accessorKey: 'overlapping',
    id: 'overlapping',
    header: 'Overlapping',
    size: 120,
    cell: (info) => ((info.getValue() as boolean) ? 'Yes' : 'No'),
    meta: { type: 'text' },
  },
  {
    accessorKey: 'removed',
    id: 'removed',
    header: 'Removed',
    size: 100,
    cell: (info) => ((info.getValue() as boolean) ? 'Yes' : 'No'),
    meta: { type: 'text' },
  },
  {
    accessorKey: 'unitType',
    id: 'unitType',
    header: 'Unit Type',
    size: 120,
    cell: (info) => (info.getValue() as string) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'unitDevelopmentType',
    id: 'unitDevelopmentType',
    header: 'Development Type',
    size: 180,
    cell: (info) => (info.getValue() as string) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'state',
    id: 'state',
    header: 'State',
    size: 100,
    cell: (info) => (info.getValue() as string) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'unitSource',
    id: 'unitSource',
    header: 'Unit Source',
    size: 120,
    cell: (info) => (info.getValue() as string) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'estimateSource',
    id: 'estimateSource',
    header: 'Estimate Source',
    size: 160,
    cell: (info) => (info.getValue() as string | null) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'basin',
    id: 'basin',
    header: 'Basin',
    size: 140,
    cell: (info) => (info.getValue() as string | null) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'tier',
    id: 'tier',
    header: 'Tier',
    size: 100,
    cell: (info) => (info.getValue() as string | null) || '--',
    meta: { type: 'text' },
  },
  {
    accessorKey: 'length',
    id: 'length',
    header: 'Length (ft)',
    size: 120,
    cell: (info) => {
      const v = info.getValue() as number | null;
      return v === null || v === undefined ? '--' : format0(v);
    },
    meta: { type: 'integer' },
  },
  {
    accessorKey: 'width',
    id: 'width',
    header: 'Width (ft)',
    size: 120,
    cell: (info) => {
      const v = info.getValue() as number | null;
      return v === null || v === undefined ? '--' : format0(v);
    },
    meta: { type: 'integer' },
  },
  {
    accessorKey: 'acreage',
    id: 'acreage',
    header: 'Acreage',
    size: 120,
    cell: (info) => formatAcreage(info.getValue() as number | null),
    meta: { type: 'decimal' },
  },
];
